
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[sport]/game-predictions/[slug]",
      function () {
        return require("private-next-pages/[sport]/game-predictions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[sport]/game-predictions/[slug]"])
      });
    }
  